import { selectModeName } from "@/store/mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { useLocalStorage } from "@faro-lotv/app-component-toolbox";

type CadVisibilityDistanceDescription = {
  /** Current value for "model visibility minimum distance" from persistent settings. */
  cadVisibilityDistanceInLocalStorage: number;
  /** Actual value to apply to OutOfCoreStreamCadModel's minVisibleDistance (depends on active mode). */
  actualCadVisibilityDistance?: number;
  /** true if the settings does not apply to current mode */
  cadVisibilityDistanceDisabled: boolean;
  /** Function to change the value of cadVisibilityDistanceInLocalStorage, and cadVisibilityDistanceInLocalStorage if applicable */
  setCadVisibilityDistanceInLocalStorage(distance: number): void;
};

/**
 * Hook for getting or updating the value of "model visibility minimum distance"
 * stored in local storage.
 *
 * @returns a pair with the current value for "model visibility minimum distance", and a function to change it
 */
export function useCadVisibilityDistance(): CadVisibilityDistanceDescription {
  const [
    cadVisibilityDistanceInLocalStorage,
    setCadVisibilityDistanceInLocalStorage,
  ] = useLocalStorage<number>("cadVisibilityDistance", 10);
  const activeMode = useAppSelector(selectModeName);
  const cadVisibilityDistanceDisabled =
    activeMode !== "walk" && activeMode !== "split";
  const actualCadVisibilityDistance = cadVisibilityDistanceDisabled
    ? undefined
    : cadVisibilityDistanceInLocalStorage;

  return {
    actualCadVisibilityDistance,
    cadVisibilityDistanceDisabled,
    cadVisibilityDistanceInLocalStorage,
    setCadVisibilityDistanceInLocalStorage,
  };
}
